import CommonPost from 'components/common/post'

export default function PostId({ post, breadcrumbs }) {
  return (
    <div>
      <div className='py-6 container'>
        <C.Breadcrumb list={ breadcrumbs } />
      </div>

      <div className='md:container py-2 md:flex justify-center mb-12'>
        <CommonPost post={ post } />
      </div>
      <C.CommonIntro />
    </div>
  )
}
